import { memo } from 'react'
import { DASH_SYMBOL } from 'app/consts'

import {
  CardContentWrapper,
  CardInformation,
  CardInformationRow,
  CardInformationTitle,
  CardInformationValue,
} from '../styles'

interface DeviceInformationCardProps {
  title: string
  value: string
  color?: string
  bgColor?: string
  order: number
}

function DeviceInformationCard({
  value,
  title,
  order,
  color,
  bgColor = '',
}: DeviceInformationCardProps) {
  if (value === DASH_SYMBOL) return null
  return (
    <CardInformation bgColor={bgColor} order={order}>
      <CardInformationRow>
        <CardContentWrapper>
          <CardInformationTitle>{title}</CardInformationTitle>
          <CardInformationValue color={color}>{value}</CardInformationValue>
        </CardContentWrapper>
      </CardInformationRow>
    </CardInformation>
  )
}

export default memo(DeviceInformationCard)
